import i18n from '../../../i18n'
import { baseDateInput, baseTextInput } from '../fieldTypes'
import { diaryDetailSearchFields } from './fields'

export const diaryDetailSearchFieldTypes = () => {
    return {
        [diaryDetailSearchFields.INTERNAL_APP_PROPERTY_ID]: {
            ...baseTextInput,
            name: diaryDetailSearchFields.INTERNAL_APP_PROPERTY_ID,
            label: i18n.t('app.common.propertyId'),
            colProps: {
                sm: 12,
            },
        },
        [diaryDetailSearchFields.FULL_NAME_SELLER]: {
            ...baseTextInput,
            name: diaryDetailSearchFields.FULL_NAME_SELLER,
            label: i18n.t('form.detailSearch.diary.fullNameSeller'),
            colProps: {
                sm: 12,
            },
        },
        [diaryDetailSearchFields.FULL_NAME_BUYER]: {
            ...baseTextInput,
            name: diaryDetailSearchFields.FULL_NAME_BUYER,
            label: i18n.t('form.detailSearch.diary.fullNameBuyer'),
            colProps: {
                sm: 12,
            },
        },
        [diaryDetailSearchFields.LOCATION]: {
            ...baseTextInput,
            name: diaryDetailSearchFields.LOCATION,
            label: i18n.t('app.common.location'),
            colProps: {
                sm: 12,
            },
        },
        [diaryDetailSearchFields.DIARY_DATE_FROM]: {
            ...baseDateInput,
            colProps: { sm: 6, className: 'pe-0' },
            name: diaryDetailSearchFields.DIARY_DATE_FROM,
            placeholder: i18n.t('app.common.from'),
        },
        [diaryDetailSearchFields.DIARY_DATE_TO]: {
            ...baseDateInput,
            colProps: { sm: 6, className: 'pe-0' },
            name: diaryDetailSearchFields.DIARY_DATE_TO,
            placeholder: i18n.t('app.common.to'),
        },
    }
}
